import React, {useCallback, useContext, useEffect, useMemo, useState} from 'react';
import EditHoliday from "./EditHoliday";
import {Box, Button, Stack} from "@mui/material";
import AddHoliday from "./AddHoliday";
import axios from "axios";
import {
    PersistedDataGridPremium,
    dateValueFormatter,
    dateValueGetter,
    downloadBlobResponse,
    serializeGridQuery
} from "@lb/mlib-components";
import ZiggyContext from "../../store/ziggy-context";


export default function HolidaysList() {
    const ziggyCtx = useContext(ZiggyContext);

    const columns = useMemo(() => [

        {
            field: 'holiday', type: 'date', disablePadding: false, headerName: 'Holiday', width: 140,
            valueFormatter: (value) => dateValueFormatter(dateValueGetter(value)),
        },
        {field: 'title', numeric: false, disablePadding: false, headerName: 'Title', width: 300},

    ], []);

    const [open, setOpen] = React.useState(false);
    const [justClicked, setJustClicked] = React.useState(0);

    const [refreshKey, setRefreshKey] = React.useState(0);
    useEffect(() => setRefreshKey((k) => k + 1), [ziggyCtx.load]);

    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

    const handlePreviousButtonClick = () => {
        setSelectedYear(new Date().getFullYear() - 1);
    };

    const handleCurrentButtonClick = () => {
        setSelectedYear(new Date().getFullYear());
    };
    const handleNextButtonClick = () => {
        setSelectedYear(new Date().getFullYear() + 1);
    };


    const previousYear = new Date().getFullYear() - 1;
    const currentYear = new Date().getFullYear();
    const nextYear = new Date().getFullYear() + 1;

    const handleClose = () => {
        setOpen(false);
        setRefreshKey((k) => k + 1);
    };

    const handleRowClick = (param) => {
        setJustClicked(param.row);
        setOpen(true);
    };

    const storageKey = `holidays/${selectedYear}`;
    const fetchFn = useCallback((gridState) =>
        axios.get(`/${storageKey}?${serializeGridQuery({...gridState, columns})}`)
            .then(r => ({rows: r.data.items ?? [], rowCount: r.data.total ?? 0})),
        [storageKey, columns]);

    const exportFn = useCallback(({sortModel, filterModel, search, columns: exportColumns}) =>
        axios.get(`/${storageKey}/export?${serializeGridQuery({sortModel, filterModel, search, exportColumns})}`, {responseType: 'blob'})
            .then(res => downloadBlobResponse(res, `holidays-${selectedYear}.xlsx`)),
        [storageKey, selectedYear]);

    return (
        <div>

            <Stack direction="row" spacing={2} sx={{
                justifyContent: "space-between",
                mb: 1
            }}>
                <Stack direction="row" spacing={2}>
                    <Button
                        variant={previousYear === selectedYear ? 'contained' : 'outlined'}
                        onClick={handlePreviousButtonClick}
                    >
                        {previousYear}
                    </Button>
                    <Button variant={currentYear === selectedYear ? 'contained' : 'outlined'}
                            onClick={handleCurrentButtonClick}>
                        {currentYear}
                    </Button>
                    <Button
                        variant={nextYear === selectedYear ? 'contained' : 'outlined'}
                        onClick={handleNextButtonClick}
                    >
                        {nextYear}
                    </Button>
                </Stack>
                <AddHoliday handleClose={handleClose}/>
            </Stack>
            <PersistedDataGridPremium
                storageKey={storageKey}
                columns={columns}
                fetchFn={fetchFn}
                exportFn={exportFn}
                getRowId={row => row.holiday}
                onRowClick={handleRowClick}
                disableRowSelectionOnClick
                searchEnabled={false}
                refreshKey={refreshKey}
                disableAggregation
                disableRowGrouping
                disablePivoting
            />

            {open && <EditHoliday holiday={justClicked} handleClose={handleClose}/>}
        </div>
    );
}